module.exports = __webpack_public_path__ + "img/527.29f3420f.png";